export function fireFullStoryEvent(eventName, data)
{
    try {
        if (window.FS) {
            window.FS.event(eventName, data || {});
        }
    }
    catch (exception) {
    }
}

export function fireFullStoryFieldChangeEvent(fieldName, fieldValue)
{
    fireFullStoryEvent('input_changed', {
        name: fieldName,
        value: fieldValue
    });
}